import { EnvType } from './environmentType';

export interface SentryBreadcrumbIntegration {
	console: boolean;
	xhr: boolean;
	fetch: boolean;
	dom?: boolean;
	history?: boolean;
	sentry?: boolean;
}

export interface SentryErrorIntegration {
	error: boolean;
	unhandled: boolean;
}

export interface SentryConfig {
	dsn: string;
	maxBreadcrumbs: number;
	attachStacktrace: boolean;
	autoSessionTracking?: boolean;
	debug: boolean;
	tracesSampleRate: number;
	environment: string;
	breadcrumb: SentryBreadcrumbIntegration;
	integrationTracingOrigins: string[];
	integrationGlobalHandlerError: boolean;
	integrationGlobalHandlerRejection: boolean;
}

export abstract class EasyEnvironment {
	version?: string;
	build?: string;
	production: boolean;
	env: EnvType;
	appUrl: string;
	setting: {
		mtspath?: string;
		lsUrl: string;
		marketSheetLsUrl: string[];
		applogApiPath?: string;
		dataTracking: boolean;
		tradingViewStorageURL: string;
		rocketChat: boolean;
		appSettingsUrl: string;
		easy2ReferralUrl: string;
	};
	oidcSettings?: any;

	sentry: {
		dsn: string;
		debug: boolean;
		environment: string;
		maxBreadcrumbs: number;
		attachStacktrace: boolean;
		tracesSampleRate: number;
		error: SentryErrorIntegration;
		breadcrumb: SentryBreadcrumbIntegration;
	};
	unleash?: {
		url: string;
		appName: string;
		clientKey: string;
		refreshInterval: number;
		environment: string;
	};
	postHog?: {
		url: string;
		token: string;
		active: boolean;
	};
}
